import { useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import { useAmountSalaries } from '../utils';
import { CurrencyAndPeriodDropdown } from './CurrencyAndPeriodDropdown';
import { useJobFilters } from './JobFilterProvider';

function formatCurrency(code: string, locale = 'en') {
  const numberFormatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0
  });

  const parts = numberFormatter.formatToParts(0);
  const symbol = parts.find(({ type }) => type === 'currency')?.value;

  return symbol !== code ? `${code} (${symbol})` : code;
}

export function CurrencySelect() {
  const { language } = useSettings();
  const { selectedCurrency, setSelectedCurrency } = useJobFilters();
  const amountSalaries = useAmountSalaries();

  const currencies = useMemo(
    () =>
      [...new Set(amountSalaries.map(({ currency }) => currency))].sort(
        (a, b) => a.localeCompare(b)
      ),
    [amountSalaries]
  );

  return (
    <CurrencyAndPeriodDropdown
      items={currencies}
      selectedItem={selectedCurrency}
      setSelectedItem={setSelectedCurrency}
      formatItem={(currency) => formatCurrency(currency, language.language)}
    />
  );
}
